import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function DashboardPage(props){
    return (
        <Container>
            <Row>
                <Col>Will Implement in the near future</Col>
            </Row>
        </Container>
    )
}

export default DashboardPage;